<template>
  <div
    ref="root"
    class="MemberAutocompleteInput"
    :class="{ disabled }"
    :value="value"
    @input="$emit('input', current)">
    <div class="input">
      <input
        v-model="search"
        @focus="focused"
        @keyup="memberSearchChanged"
        @keyup.enter="selectIndex"
        @keyup.down="selectDown"
        @keydown.up="selectUp"
        autocomplete="off"
        :disabled="disabled">
      <span class="icon">
        <Icon
          v-if="working"
          name="loading" />
        <Icon
          v-if="!working"
          name="search" />
      </span>
    </div>
    <ul
      v-if="showOptions"
      class="panel">
      <li
        v-for="(option, index) in options"
        :class="{ selected: index === selected }"
        @mouseover="setSelected(index)"
        :key="option.id"
        @click="select(option)">
        <div class="gender">
          <GenderAge
            :birthdate="option.customer.birthdate"
            :gender="option.customer.gender" />
        </div>
        <div class="personalia">
          {{ option.customer.firstName }} {{ option.customer.lastName }}<br>
          {{ option.customer.mobileNumber }}
          {{ option.location.name }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import gql from "graphql-tag";
import debounce from "lodash/debounce";
import GenderAge from "@/components/GenderAge";

export default {
  components: { GenderAge },
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      working: false,
      current: this.value,
      search: this.memberLabel(this.value),
      showOptions: false,
      selected: -1,
      options: [],
    };
  },

  mounted() {
    document.addEventListener('click', this.outsideClickHandler);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.outsideClickHandler);
  },

  methods: {
    outsideClickHandler(ev) {
      if (!this.$refs.root.contains(ev.target)) {
        this.blurred();
      }
    },
    memberSearchChanged: debounce(function () {
      if (this.search.length < 2) {
        return;
      }
      this.working = true;
      this.$apollo
        .query({
          query: gql`
          query MembershipSearch ($q: String!) {
            __typename
            membershipSearchList(q: $q, first: 10) {
              customer {
                firstName
                lastName
                mobileNumber
                birthdate
                gender
                mobilePrefix
              }
              id
              location {
                id
                name
              }
            }
          }
          `,
          variables: { q: this.search },
        })
        .then((result) => {
          this.options = result.data.membershipSearchList;
        })
        .finally(() => (this.working = false));
    }, 500),

    memberLabel(m) {
      if (m) {
        return `${m.customer.firstName} ${m.customer.lastName}`;
      }
      return "";
    },

    focused(e) {
      e.currentTarget.select();
      this.showOptions = true;
    },

    blurred() {
      this.showOptions = false;
      if (this.current) {
        this.search = this.memberLabel(this.current);
      } else if (this.selected === -1) {
        this.search = "";
      }
    },

    select(option) {
      this.showOptions = false;
      this.current = option;
      this.search = this.memberLabel(this.current);
      this.$emit("input", this.current);
    },

    setSelected(index) {
      this.selected = index;
    },

    selectUp() {
      if (this.selected > 0) {
        this.selected -= 1;
      }
    },

    selectDown() {
      if (this.selected < this.options.length) {
        this.selected += 1;
      }
    },

    selectIndex() {
      this.select(this.options[this.selected]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";

.MemberAutocompleteInput {
  position: relative;
  display: inline-block;
  flex: 1;

  .disabled {
    opacity: 0.25;
  }

  ul.panel {
    padding: 0 !important;
  }

  .input {
    display: flex;
    align-items: center;
    flex: 1;

    .icon {
      position: absolute;
      right: 1em;
    }
  }

  ul {
    list-style: none;
    z-index: 1;
    top: 100%;
    left: 0;
    right: 0;
    position: absolute;
    max-height: 10em;
    overflow: auto;
    padding: 0;
    margin: 0;

    li {
      padding-top: 1em;
      padding-bottom: 1em;
      cursor: pointer;
      display: flex;
      align-items: flex-start;

      .gender {
        width: 3em;
        padding-right: 3px;
      }

      .personalia {
      }
    }

    .selected {
      background-color: var(--pale-grey);
    }
  }
}
</style>
